<div class="slider-container">
    <lib-slider *ngIf="showTimeline" [min]="min" [max]="duration" [value]="playerValue" [buffer]="bufferValue"
        [startDate]="startDate" [endDate]="endDate" [realtime]="isRealtime()" (valueChange)="onSliderMove($event)">
    </lib-slider>
</div>

<div class="player-menu" [ngClass]="{ 'replay': isReplay() }">
    <div class="date-picker">
        <app-date-picker *ngIf="!showEndDate" [startDate]="startDate.toISOString()" [min]="project.createdDate"
            (dateChanged)="onPickerChanged($event)" [activity]="activity">
        </app-date-picker>

        <app-range-picker *ngIf="showEndDate" [startDate]="startDate.toISOString()" [endDate]="endDate.toISOString()"
            [min]="project.createdDate" (change)="onPickerChanged($event)" [activity]="activity">
        </app-range-picker>

        <lib-button *ngIf="!showEndDate" size="small" color="none" icon="date_range" (click)="onShowEndChange()"
            tooltip="{{ 'dashboard.enable_date_range' | translate }}">
        </lib-button>

        <lib-button *ngIf="showEndDate" size="small" color="none" icon="close" (click)="onShowEndChange()">
        </lib-button>
    </div>

    <div class="player-group">
        <div class="group">
            <lib-button mat-icon-button id="button_fbw" (click)="playerValue = 0" color="none" textColor="tertiary"
                icon="skip_previous">
            </lib-button>

            <lib-button id="button_play" (click)="onPlay()" *ngIf="playerState == 'stop'" color="none"
                textColor="tertiary" icon="play_arrow">
            </lib-button>

            <lib-button id="button_play" (click)="onPlay()" *ngIf="playerState == 'pause'" color="none"
                textColor="tertiary" icon="play_arrow">
            </lib-button>

            <lib-button id="button_play" color="none" textColor="tertiary" (click)="onPlay()" icon="pause_circle_filled"
                *ngIf="this.playerState == 'play' || this.playerState == 'resume'">
            </lib-button>

            <lib-button id="button_stop" (click)="stop()" color="none" textColor="tertiary" icon="stop">
            </lib-button>

            <lib-button id="button_ffw" (click)="seekForwardViewer()" color="none" textColor="tertiary"
                icon="skip_next">
            </lib-button>
        </div>
    </div>

    <div class="options">
        <mat-form-field appearance="outline" size="small" class="speed-select" subscriptSizing="dynamic">
            <mat-select [(ngModel)]="speed" placeholder="{{'viewer.speed' | translate}}">
                <mat-option [value]="1">x1</mat-option>
                <mat-option [value]="2">x2</mat-option>
                <mat-option [value]="4">x4</mat-option>
                <mat-option [value]="8">x8</mat-option>
                <mat-option [value]="16">x16</mat-option>
                <mat-option [value]="32">x32</mat-option>
                <mat-option [value]="64">x64</mat-option>
            </mat-select>
        </mat-form-field>

        <lib-button [matMenuTriggerFor]="menu" color="muted" icon="more_horiz">
        </lib-button>

        <mat-menu #menu="matMenu">
            <button mat-menu-item class="toggle-menu-item">
                <mat-slide-toggle [(ngModel)]="showTimeline" (change)="toggleTimeline($event.checked)">
                    {{'viewer.show_timeline' | translate}}
                </mat-slide-toggle>
            </button>

            <button mat-menu-item id="saveEventViewer" title="Save Event" (click)="saveEvent()">
                <mat-icon>event</mat-icon>
                {{'viewer.add_event' | translate}}
            </button>

            <button mat-menu-item (click)="embedLink()">
                <mat-icon>code</mat-icon>
                {{'viewer.embedLink' | translate}}
            </button>
        </mat-menu>
    </div>

    <lib-button class="currentTime" [text]="currentDateSignal()" color="outline" icon="access_time">
    </lib-button>

    <lib-button *ngIf="isReplay()" (click)="onPlayModeChanged('realtime')" color="primary"
        text="{{'workflows.realtime' | translate}}" icon="update" class="mode-realtime-btn"
        [ngClass]="{ 'show': isReplay(), 'hide': !isReplay() }">
    </lib-button>


    <div id="model" class="player text-center player-group player-item-3">
        <mat-form-field appearance="outline" size="small" class="input-full-width model-select">
            <mat-label>{{'viewer.model' | translate}}</mat-label>

            <mat-select id="model" (selectionChange)="onModelChanged()" [(value)]="project.model"
                placeholder="{{'viewer.model' | translate}}">
                <mat-option *ngFor="let model of models()" value="{{model.id}}">
                    {{model.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>

<div id="eventText"></div>